import {
    Check,
    ConfirmModal,
    CustomButton,
    TitleAndTable,
    WarningModal
} from "components/Common"
import { ModuleIds, permissionType } from "constant"
import {
    getUrlParamByKey,
    getUrlParams,
    insertUrlParam,
    onDelete,
    onDeleteToggle,
    selectCheckboxHandler
} from "helpers/utilities"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
//i18n
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { addNewMachine, deleteMachines, getMachineDetail, getMachines, resetMachineSearchQuery, updateMachine } from "store/connector/instruments/actions"
import MachineTable from "./MachineTable"
import MachineModal from "./Modal/MachineModal"

const RESOURCE = ModuleIds.Instrument

const Machines = ({
    history,
    machines,
    paging,
    onGetMachines,
    onAddNewMachine,
    onUpdateMachine,
    onDeleteMachine,
    onResetMachineSearchQuery,
    onGetMachineDetail,
    loadingMachines,
    updateMachineTime,
    machine,
    t,
}) => {
    const [confirmModal, setConfirmModal] = useState(false)
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(true)
    const [isClone, setIsClone] = useState(false)
    const [row, setRow] = useState({})
    const [rowDelete, setRowDelete] = useState({})
    const [rows, setRows] = useState([])

    const [warningModal, setWarningModal] = useState(false)

    const formEl = useRef(null)

    useEffect(() => {
        window.addEventListener('popstate', (event) => popStateChange(event));
    }, []);

    const popStateChange = (event) => {
        let params = getUrlParams();
        let paramPage = getUrlParamByKey("page");
        if (paramPage) {
            onGetMachineList(params)
        }
    }

    useEffect(() => {
        let params = getUrlParams();
        let paramPage = getUrlParamByKey("page");
        if (paramPage) {
            onGetMachineList(params)
        } else {
            onGetMachines()
        }
    }, [])

    const onGetMachineList = (payload) => {
        insertUrlParam(payload)
        onGetMachines(payload)
    }

    const toggle = () => {
        setModal(prev => !prev)
    }

    const addMachineClicks = () => {
        setIsEdit(false)
        setIsClone(false)
        toggle()
    }

    const handleValidSubmit = (e, values) => {
        if (isEdit) {
            values.status = values.statuss
            delete values.statuss
            onUpdateMachine({ machine: values, callback: toggle })
        } else {
            const newItem = {
                ...values,
                status: !!values["statuss"],
                instrumentID: parseInt(values["instrumentID"])
            }
            delete newItem.statuss
            onAddNewMachine({ machine: newItem, history })
        }
    }

    const onCloneHandler = (param) => {
        const id = param || row?.id
        if (id) {
            onGetMachineDetail(id)
            setIsEdit(false)
            setIsClone(true)
            toggle()
        } else setWarningModal(true)
    }

    const onEditHandler = (e, paramId) => {
        const id = paramId || row?.id
        if (id) {
            onGetMachineDetail(id)
            setIsEdit(true)
            toggle()
        } else setWarningModal(true)
    }

    const resetState = () => {
        setRows([])
        setRow({})
    }

    const onDeleteToggleHandler = (e, param) => {
        onDeleteToggle({
            rows,
            row: param || rowDelete,
            setConfirmModal,
            setWarningModal,
            setRowDelete,
        })
        if (confirmModal) setRowDelete({})
    }

    const onDeleteMultipleRows = rowsState => {
        onDeleteMachine({ machines: rowsState, callback: resetState })
    }

    const onDeleteSingleRow = rowsState => {
        onDeleteMachine({
            machines: rowsState,
            callback: () => {
                setRows(prev => prev.filter(x => x.id !== rowDelete.id))
            },
        })
        setRowDelete({})
        setRow({})
    }

    const onDeleteMachineHandler = () => {
        onDelete({
            rowDelete,
            rows,
            onDeleteSingleRow,
            onDeleteMultipleRows,
        })
        setConfirmModal(false)
    }

    /**Get selected row and set to state
     *
     */
    const onSelectCheckbox = (row, isSelected) => {
        const { rowsState, currentRow } = selectCheckboxHandler(
            rows,
            row,
            isSelected
        )
        setRows(rowsState)
        setRow(currentRow)
    }

    const onSelectAllCheckbox = rows => {
        setRows(rows)
        if (rows.length < 1) setRow({})
        else setRow(rows[rows.length - 1])
    }

    const fetchMachines = () => {
        onGetMachineList({ page: 1 })
    }

    /** Table methods */
    const onRefreshHandler = () => {
        resetState()
        fetchMachines()
    }

    const onSearch = searchText => {
        onGetMachineList({ page: 1, search: searchText })
    }

    const onSizePerPageChange = size => {
        onGetMachineList({ page: 1, size })
    }

    const onPageChange = page => {
        onGetMachineList({ page })
    }

    const onSubmitFilter = values => {
        onGetMachineList({ page: 1, ...values })
    }

    const onSortHandler = (field, order) => {
        const sortString = `${field}:${order}`
        onGetMachineList({ page: 1, sort: sortString })
    }

    /**-----CYCLE------ */

    useEffect(() => {
        onResetMachineSearchQuery()
    }, [])

    return (
        <React.Fragment>
            {/* Body */}
            <TitleAndTable
                table={() => (
                    <MachineTable
                        machines={machines}
                        onSelect={onSelectCheckbox}
                        onSelectAll={onSelectAllCheckbox}
                        onSearch={onSearch}
                        onSort={onSortHandler}
                        onRefresh={onRefreshHandler}
                        onPageChange={onPageChange}
                        paging={paging}
                        onSizePerPageChange={onSizePerPageChange}
                        onSubmitFilter={onSubmitFilter}
                        onEdit={onEditHandler}
                        onDelete={onDeleteToggleHandler}
                        onClone={onCloneHandler}
                        loading={loadingMachines}
                        updatedTime={updateMachineTime}
                    />
                )}
                resource={RESOURCE}
                buttons={() => (<>
                    <Check permission={permissionType.C} resource={RESOURCE}>
                        <CustomButton color="primary" onClick={addMachineClicks} outline>
                            {t("common:Add")}
                        </CustomButton>
                    </Check>
                    <Check permission={permissionType.D} resource={RESOURCE}>
                        <CustomButton color="primary" onClick={(e) => { onDeleteToggleHandler(e, rows.id) }} outline>
                            {t("common:Delete")}
                        </CustomButton>
                    </Check>
                </>)}
                onEdit={onEditHandler}
                onDelete={onDeleteToggleHandler}
                onClone={onCloneHandler}
                isDisableClone
                isHideEdit
                isDropDown
                title={t("Instruments")}
                subtitle={t("Instrument List")}
            />


            <WarningModal
                modal={warningModal}
                onToggle={() => setWarningModal(prev => !prev)}
                message={t("message:SelectRowWarning")}
            />
            <ConfirmModal
                modal={confirmModal}
                title={`${t("common:Delete")} ${t("Instrument")}`}
                message={t("message:DeleteConfirm")}
                onToggle={onDeleteToggleHandler}
                onDelete={onDeleteMachineHandler}
            />
            <MachineModal
                formEl={formEl}
                modal={modal}
                isEdit={isEdit}
                onValidSubmit={handleValidSubmit}
                toggle={toggle}
                data={!isEdit ? (isClone ? machine : {}) : machine}
            />
        </React.Fragment>
    )
}

Machines.propTypes = {
    machines: PropTypes.array,
    onGetMachineDetail: PropTypes.func,
    onGetMachines: PropTypes.func,
    onAddNewMachine: PropTypes.func,
    onUpdateMachine: PropTypes.func,
    onDeleteMachine: PropTypes.func,
    onResetMachineSearchQuery: PropTypes.func,
    paging: PropTypes.object,
    loadingMachines: PropTypes.bool,
    updateMachineTime: PropTypes.any,
    t: PropTypes.any,
}

const mapStateToProps = ({ machine }) => {
    return ({
        machines: machine.machines,
        machine: machine.machine,
        paging: machine.paging,
        loadingMachines: machine.loadingMachine,
        updateMachineTime: machine.updateMachineTime,
    })
}

const mapDispatchToProps = dispatch => ({
    onGetMachines: payload => dispatch(getMachines(payload)),
    onAddNewMachine: (machine, history) => dispatch(addNewMachine(machine, history)),
    onUpdateMachine: machine => dispatch(updateMachine(machine)),
    onDeleteMachine: machine => dispatch(deleteMachines(machine)),
    onGetMachineDetail: machineId => dispatch(getMachineDetail(machineId)),
    onResetMachineSearchQuery: () => dispatch(resetMachineSearchQuery()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation(["machinePage", "message", "common"])(Machines)))
